import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addCompany } from "../../../store/actions/Companies/companyActions";
import { debounce } from "../../../utils/debounce";
import { get } from "../../../services/api";




const AddCompany = forwardRef((props, ref) => {


  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
    const [sourceList, setSourceList] = useState([]);
  
  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(`https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`);
    const result = await apiData.json();

      
      // Destructure and rewrap into a new variable `address`
      const address = {
        addressLine1: result.line_1 || "",
        addressLine2: result.line_2 || "",
        addressLine3: result.line_3 || "",
        town: result.town_or_city || "",
        county: result.county || "",
        country: result.country || "",
        postcode: result.postcode || "",
        region: result.region || "",
      };

      // Update the form data with the new address details
      setFormData((prevFormData) => ({
          ...prevFormData,
          address
      }));
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  useEffect(() => {
      if (props?.companySources) {
        setSourceList(props?.companySources?.map((itm) => itm.value));
      }
    }, [props?.companySources]);

  
  const fetchData = async (searchTerm) => {
    const apiData = await fetch(`https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`);
    const result = await apiData.json();
    setResults(result.suggestions);
    console.log(results)
  };
  
      // Handle input changes
      const handlePostCodeQueryChange = (inputQuery) => {
        setQuery(inputQuery); // Update input state
        debounce(fetchData(inputQuery)); // Call the debounced function
      };

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    companyName: "",
    address: {
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      town: "",
      county: "",
      country: "",
      postcode: "",
      region: "",
    },
    contact: {
      office: "",
    },
    email: "",
    website: "",
    business: "Rapid Resourcing Ltd",
    office: "Liverpool",
    sector: "",
    clientId: "",
    consultant: "",
    regDate: new Date(),
    source: "",
    lastContactDate: null,
    statusDate: null,
    status: "CLIENT",
    isParentCompany: "Yes",
    
  });
  const resetForm = () => {
    setFormData({
      companyName: "",
      address: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        town: "",
        county: "",
        country: "",
        postcode: "",
        region: "",
      },
      contact: {
        office: "",
      },
      email: "",
      website: "",
      business: "Rapid Resourcing Ltd",
      office: "Liverpool",
      sector: "",
      clientId: "",
      consultant: "",
      regDate: null,
      source: "",
      lastContactDate: null,
      statusDate: null,
      status: "CLIENT",
      isParentCompany: "Yes",
      
    })
    setErrors({})
  }
  const [errors, setErrors] = useState({});
  const [addEmploye, setAddCompany] = useState(false);

  useImperativeHandle(ref, () => ({
    showEmployeModal() {
      if(!formData?.clientId) {
        setclientId();
      }
      setAddCompany(true);
    },
  }));

  const validate = () => {
    const newErrors = {};
    const requiredFields = ["companyName", "status"];
  
    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });
  
    // Check nested address fields
    const addressRequiredFields = ["addressLine1", "town", "country", "postcode"];
    addressRequiredFields.forEach((field) => {
      if (!formData.address[field]?.trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });
  
    if (
      formData.contact.office && 
      !/^(?:\+44|0)\d{10}$/.test(formData.contact.office)
    ) {
      newErrors.office = "Company Telephone Number must be a valid UK number.";
    }
  
    // Additional validations
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email must be valid.";
    }

    if (formData.website && !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/.test(formData.website)) {
      newErrors.website = "Website must be valid URL.";
    }
  
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all required fields.");
    }
  
    return Object.keys(newErrors).length === 0;
  };
  

  const handleInputChange = (field, value, nested = null) => {
    if(field === "postcode"){
      handlePostCodeQueryChange(value);
    }

    if (nested) {
      setFormData((prev) => ({
        ...prev,
        [nested]: { ...prev[nested], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      formData.isParent = formData?.isParentCompany === "Yes";
      formData.email = formData.email?.toLowerCase();
      dispatch(addCompany(formData, setAddCompany, props.token, resetForm));
    }
  };

  useEffect(() => {
    if(!formData?.clientId) {
      setclientId();
    }
  }, [])

  const setclientId = async ()=> {
    const clientId = await get('/api/sequence/company-client-id', props.token);
    setFormData({ ...formData, clientId: clientId.value });
  }

  return (
    <Offcanvas
      show={addEmploye}
      onHide={() => {
        resetForm();
        setAddCompany(false);
      }}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => { 
            resetForm();
            setAddCompany(false)
          }}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Company Name */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Company Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.companyName}
                onChange={(e) =>
                  handleInputChange("companyName", e.target.value)
                }
              />
              {errors.companyName && (
                <small className="text-danger">{errors.companyName}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Is Parent Company
              </label>
              <select
                className="form-control"
                value={formData.isParentCompany}
                onChange={(e) => handleInputChange("isParentCompany", e.target.value)}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            {formData?.isParentCompany === 'No' &&
            <div className="col-xl-6 mb-3">
            <label className="form-label">
              Parent Company
            </label>
            {/* <Select
                  //isMulti
                  options={props?.companies?.map(c => { return { value: c?._id, label: c?.companyName } })}
                  className="custom-react-select"
                  isSearchable={true}
                  onChange={(e) => handleInputChange("subsidiary", Array.from(e.target.selectedOptions, option => option.value))}
                /> */}
            <select
              className="form-control form-select"
              value={formData.parentCompany}
              onChange={(e) => handleInputChange("parentCompany", e.target.value)}
             >
              <option value="">Select</option>
              {props?.companies?.map(c => (
                <option key={c?._id} value={c?._id}>
                  {c?.companyName}
                </option>
              ))}
            </select>
          </div>
            }

            {/* Address Fields */}
            {[
              { label: "Postcode", field: "postcode", required: true },
              {
                label: "Address Line 1",
                field: "addressLine1",
                required: true,
              },
              { label: "Address Line 2", field: "addressLine2" },
              { label: "Address Line 3", field: "addressLine3" },
              { label: "Town", field: "town", required: true },
              { label: "County", field: "county", required: false },
              { label: "Country", field: "country", required: true },
              // { label: "Region", field: "region", required: false },
            ].map(({ label, field, required = false }) => (
              <div className="col-xl-6 mb-3" key={field}>
                <label className="form-label">
                  {label} {required && <span className="text-danger">*</span>}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.address[field]}
                  onChange={(e) =>
                    handleInputChange(field, e.target.value, "address")
                  }
                />
                {(field === "postcode" && results?.length > 0) && (
                          <div
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            maxHeight: "150px", // Medium size scrollable div
                            overflowY: "auto",
                            marginTop: "5px",
                            padding: "10px",
                            backgroundColor: "#fff",
                          }}>
                          {results?.map((suggestion, index) => (
                          <div
                          key={index}
                          style={{
                            padding: "5px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          onClick={() => handleSuggestionClick(suggestion)} // Handle click on suggestion
                          >
                          {suggestion.address}
                        </div>
                      ))}
                      </div>
                      )}
                {errors[field] && (
                  <small className="text-danger">{errors[field]}</small>
                )}
              </div>
            ))}

            {/* Contact Office */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Company Telephone Number
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.contact.office}
                onChange={(e) =>
                  handleInputChange("office", e.target.value, "contact")
                }
              />
              {errors.office && (
                <small className="text-danger">{errors.office}</small>
              )}
            </div>

            {/* Email, Website, Sector */}
            {[
              { label: "Email", field: "email", type: "email" },
              { label: "Website", field: "website", type: "text" },
              //{ label: "Sector", field: "sector", type: "text" },
            ].map(({ label, field, type }) => (
              <div className="col-xl-6 mb-3" key={field}>
                <label className="form-label">{label}</label>
                <input
                  type={type}
                  className="form-control"
                  value={formData[field]}
                  onChange={(e) => handleInputChange(field, e.target.value)}
                />
                {errors[field] && (
                  <small className="text-danger">{errors[field]}</small>
                )}
              </div>
            ))}

            {/* Client ID */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Client ID <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                disabled
                className="form-control"
                value={formData.clientId}
              />
            </div>

            {/* Registration Date, Last Contact Date, Status Date */}
            {[
              { label: "Registration Date", field: "regDate" },
              // { label: "Last Contact Date", field: "lastContactDate" },
              // { label: "Status Date", field: "statusDate" },
            ].map(({ label, field }) => (
              <div className="col-xl-6 mb-3" key={field}>
                <label className="form-label">{label}</label>
                <DatePicker
                  className="form-control"
                  selected={formData[field]}
                  onChange={(date) => handleInputChange(field, date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
            ))}

            {/* Status */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={formData.status}
                onChange={(e) => handleInputChange("status", e.target.value)}
              >
                <option value=""></option>
                <option value="CLIENT">CLIENT</option>
                <option value="PROSPECT">PROSPECT</option>
                <option value="ARCHIVED">ARCHIVED</option>
              </select>
              {errors.status && (
                <small className="text-danger">{errors.status}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
                          <label className="form-label">Source </label>
                          <select
                            className="form-control form-select"
                            value={formData.source}
                            onChange={(e) =>
                              handleInputChange("source", e.target.value)
                            }
                          >
                            <option value="" disabled></option>
                            {sourceList?.map((itm) => <option value={itm}>{itm}</option>)}
                          </select>
                        </div>
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <Link
            to={"#"}
            onClick={() => {
              resetForm();
              setAddCompany(false)
            }}
            className="btn btn-danger ms-2"
          >
            Cancel
          </Link>
        </form>
      </div>
    </Offcanvas>
  );
});

export default AddCompany;
